import { render, staticRenderFns } from "./CommunityBuilds.vue?vue&type=template&id=732b1601&scoped=true&"
import script from "./CommunityBuilds.vue?vue&type=script&lang=js&"
export * from "./CommunityBuilds.vue?vue&type=script&lang=js&"
import style0 from "./CommunityBuilds.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CommunityBuilds.vue?vue&type=style&index=1&id=732b1601&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732b1601",
  null
  
)

export default component.exports